<template>
  <b-modal
      :title="$t('history.modal.header.TransferToCargoWise')"
      ref="cargowise-transfer-modal"
      @ok="doTransfer"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="cancel()">Cancel</b-button>
      <b-button @click="ok()" name="transferToCargoWiseModalButton" variant="primary">{{
          $t('history.modal.button.Transfer')
        }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import {CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX} from '@/store/constants';
import helpers from '@/helper';
import {mapGetters} from 'vuex';
import vSelect from '../../vSelect';

export default {
  props: {
    deliveryStatus: {type: String}
  },

  components: {
    vSelect
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('history', ['getSelectedRows', 'getDeliverStatusesWithoutUndelivered'])
  },

  methods: {
    showCargoWiseTransferModal() {
      this.$refs['cargowise-transfer-modal'].show();
    },

    doTransfer() {
      this.$emit('transferShipmentsToCW1');
      
    }
  }
};
</script>

<style></style>
